import {
  SET_USER,
  LOGOUT_USER,
  NOTIFICATION,
} from 'context/constants';

export const setUser = (user) => {
  localStorage.setItem('token', user.api_token);
  return { type: SET_USER, token: user.api_token, user, isLogin: true };
};

export const logOutUser = () => {
  localStorage.removeItem('token');
  return { type: LOGOUT_USER };
};

export const notification = (notification) => ({
  type: NOTIFICATION,
  ...notification
});